import script from "./FicheUtilisateurView.vue?vue&type=script&setup=true&lang=js"
export * from "./FicheUtilisateurView.vue?vue&type=script&setup=true&lang=js"

import "./FicheUtilisateurView.vue?vue&type=style&index=0&id=df88bbd2&lang=css"

const __exports__ = script;

export default __exports__